<template>
    <div class="disable-text-selection">
        <b-row class="invoice-header-vue">
            <b-colxx xxs="12">
                <div class="mb-5 invoice-header-print-contents">
                    <div class="h3">Print Preview
                        <b-button variant="primary" size="sm" class="float-right">PRINT</b-button>
                    </div>
                </div>
            </b-colxx>
        </b-row>

        <b-row class="invoice-header-vue">
            <b-colxx xxs="12">
                <b-card class="mb-5 invoice-header-contents" no-body>
                    <b-card-body>{{ $t('pages.invoice-info') }}</b-card-body>
                </b-card>
            </b-colxx>
        </b-row>

        <b-row class="invoice-vue">
            <b-colxx xxs="12">
                <b-card class="mb-5 invoice-contents" no-body>
                    <b-card-body class="d-flex flex-column justify-content-between">
                        <div class="d-flex flex-column">
                            <div class="d-flex flex-row justify-content-between pt-2 pb-2">
                                <div class="d-flex align-self-center">
                                    <img src="/default/logo-black.svg"/>
                                </div>
                                <div class="d-flex w-30 text-right align-self-center">
                                    <p class="text-small text-semi-muted mb-0">Sprint Devs<br/>Demo environment</p>
                                </div>
                            </div>
                            <div class="border-bottom pt-4 mb-5"></div>
                            <div class="d-flex flex-row justify-content-between mb-5">
                                <div class="d-flex flex-column w-70 mr-2 p-4 text-semi-muted bg-semi-muted">
                                    <p class="mb-0">Demo Resident</p>
                                    <p class="mb-0">Demo record</p>
                                </div>
                                <div class="d-flex w-30 flex-column text-right p-4 text-semi-muted bg-semi-muted">
                                    <p class="mb-0">Invoice #: 741</p>
                                    <p class="mb-0">02.02.2019</p>
                                </div>
                            </div>

                            <table class="table table-borderless">
                                <thead>
                                <tr>
                                    <th class="text-muted text-extra-small mb-2">ITEM NAME</th>
                                    <th class="text-muted text-extra-small mb-2">COUNT</th>
                                    <th class="text-right text-muted text-extra-small mb-2">PRICE</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Marble Cake</td>
                                    <td>3 pcs</td>
                                    <td class="text-right">$ 14.82</td>
                                </tr>
                                <tr>
                                    <td>Chocolate Cake</td>
                                    <td>2 pcs</td>
                                    <td class="text-right">$ 8.97</td>
                                </tr>
                                <tr>
                                    <td>Fat Rascal</td>
                                    <td>2 pcs</td>
                                    <td class="text-right">$ 18.24</td>
                                </tr>
                                <tr>
                                    <td>Cremeschnitte</td>
                                    <td>2 pcs</td>
                                    <td class="text-right">$ 4.24</td>
                                </tr>
                                <tr>
                                    <td>Cheesecake</td>
                                    <td>3 pcs</td>
                                    <td class="text-right">$ 6.27</td>
                                </tr>
                                <tr>
                                    <td>Magdalena</td>
                                    <td>2 pcs</td>
                                    <td class="text-right">$ 10.97</td>
                                </tr>
                                <tr>
                                    <td>Genoise</td>
                                    <td>2 pcs</td>
                                    <td class="text-right">$ 21.24</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="d-flex flex-column">
                            <div class="border-bottom pt-3 mb-5"></div>
                            <table class="table table-borderless d-flex justify-content-end">
                                <tbody>
                                <tr>
                                    <td class="text-semi-muted">Subtotal :</td>
                                    <td class="text-right">$ 61.82</td>
                                </tr>
                                <tr>
                                    <td class="text-semi-muted">Tax :</td>
                                    <td class="text-right">$ 61.82</td>
                                </tr>
                                <tr>
                                    <td class="text-semi-muted">Shipping :</td>
                                    <td class="text-right">$ 3.21</td>
                                </tr>
                                <tr class="font-weight-bold">
                                    <td class="text-semi-muted">Total :</td>
                                    <td class="text-right">$ 68.14</td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="border-bottom pt-3 mb-5"></div>
                            <p class="text-muted text-small text-center">Invoice was created on a computer and is valid
                                without the signature and seal.<br>
                            Printed by: Demo Administrator, Printed at: 04-10-2020, 11:42 AM</p>
                        </div>

                    </b-card-body>
                </b-card>
            </b-colxx>
        </b-row>

        <v-contextmenu ref="contextmenu" @contextmenu="handleContextmenu">
            <v-contextmenu-item @click="onContextCopy()"><i class="simple-icon-docs"/> <span>Copy</span>
            </v-contextmenu-item>
            <v-contextmenu-item @click="onContextArchive()"><i class="simple-icon-drawer"/> <span>Move to archive</span>
            </v-contextmenu-item>
            <v-contextmenu-item @click="onContextDelete()"><i class="simple-icon-trash"/> <span>Delete</span>
            </v-contextmenu-item>
        </v-contextmenu>

        <application-menu>
            <vue-perfect-scrollbar :settings="{ suppressScrollX: true, wheelPropagation: false }">
                <div class="p-4">
                    <p class="text-muted text-small mb-3">Choose options to generate reports</p>
                    <ul class="list-unstyled mb-4">
                        <li class="nav-item"><a href="#">
                            <span class="d-inline-block">{{$t('todo.all-tasks')}}</span>
                            <span class="float-right" v-if="isLoad">{{items.length}}</span>
                        </a></li>
                        <li class="nav-item"><a href="#">
                            <i class="simple-icon-refresh"/><span
                            class="d-inline-block">{{$t('todo.pending-tasks')}}</span> <span class="float-right"
                                                                                             v-if="isLoad">{{items.filter(x => x.status === "PENDING").length}}</span>
                        </a></li>
                        <li class="nav-item"><a href="#">
                            <i class="simple-icon-check"/><span
                            class="d-inline-block">{{$t('todo.completed-tasks')}}</span> <span class="float-right"
                                                                                               v-if="isLoad">{{items.filter(x => x.status === "COMPLETED").length}}</span>
                        </a></li>
                    </ul>

                    <b-form-group label="State" class="has-float-label">
                        <template v-slot:label>
                            <span>Select Category <sup><code>*</code></sup></span>
                        </template>

                        <v-select v-model="vueSelectForm.single" :options="selectData" :dir="direction"/>
                    </b-form-group>
                    <b-form-group label="State" class="has-float-label">
                        <template v-slot:label>
                            <span>Facility <sup><code>*</code></sup></span>
                        </template>

                        <v-select v-model="vueSelectForm.single" :options="selectData" :dir="direction"/>
                    </b-form-group>
                    <p class="text-muted text-small mb-1">{{$t('todo.categories')}}</p>
                    <ul class="list-unstyled mb-4">
                        <b-form-radio-group stacked class="pt-2"
                                            :options="categories.map((c)=> {return {text:c.label,value:c.value}})"/>
                    </ul>
                    <p class="text-muted text-small mb-3">{{$t('todo.labels')}}</p>
                    <div>
                        <p class="d-sm-inline-block mb-1" v-for="(l,index) in labels" :key="index">
                            <a href="#">
                                <b-badge pill :variant="`outline-${l.color}`" class="mb-1 mr-1">{{l.label}}</b-badge>
                            </a>
                        </p>
                    </div>
                </div>
            </vue-perfect-scrollbar>
        </application-menu>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapMutations,
        mapActions
    } from 'vuex'

    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'
    import TodoListItem from '../../../components/TodoApp/TodoListItem'
    import ApplicationMenu from '../../../components/Common/ApplicationMenu'

    export default {
        components: {
            'v-select': vSelect,
            'todo-list-item': TodoListItem,
            'application-menu': ApplicationMenu
        },
        data() {
            return {
                selectData: [
                    'Vendors',
                    'Facilities',
                    'Clients',
                    'Inspections',
                    'Complaints',
                    'Signatures',
                    'Billings'
                ],
                vueSelectForm: {
                    single: '',
                    multiple: []
                },
                sort: {
                    column: 'title',
                    label: 'Title'
                },
                sortOptions: [{
                    column: 'title',
                    label: 'Title'
                },
                    {
                        column: 'category',
                        label: 'Category'
                    },
                    {
                        column: 'label',
                        label: 'Label'
                    },
                    {
                        column: 'status',
                        label: 'Status'
                    }
                ],
                search: '',
                selectedItems: [],
                categories: [{
                    label: 'Flexbox',
                    value: 'Flexbox'
                },
                    {
                        label: 'Sass',
                        value: 'Sass'
                    },
                    {
                        label: 'Vue',
                        value: 'Vue'
                    },
                    {
                        label: 'React',
                        value: 'React'
                    }
                ],
                labels: [{
                    label: 'EDUCATION',
                    value: 'EDUCATION',
                    color: 'secondary'
                },
                    {
                        label: 'NEW FRAMEWORK',
                        value: 'NEW FRAMEWORK',
                        color: 'primary'
                    },
                    {
                        label: 'PERSONAL',
                        value: 'PERSONAL',
                        color: 'info'
                    }
                ],
                statuses: [{
                    text: 'PENDING',
                    value: 'PENDING'
                },
                    {
                        text: 'COMPLETED',
                        value: 'COMPLETED'
                    }
                ],
                newItem: {
                    title: '',
                    category: '',
                    detail: '',
                    label: '',
                    status: ''
                }

            }
        },
        computed: {
            ...mapGetters(['isLoad', 'items', 'todoError'])
        },
        methods: {
            ...mapActions(['getTodoItems']),
            ...mapMutations(['addTodoItem']),
            isSelectedAll() {
                return this.selectedItems.length >= this.items.length
            },
            isAnyItemSelected() {
                return this.selectedItems.length > 0 && this.selectedItems.length < this.items.length
            },
            hideModal(refname) {
                this.$refs[refname].hide()
            },
            changeOrderBy(sort) {
                this.sort = sort
            },
            addNewItem() {
                const date = new Date()
                this.addTodoItem({
                    title: this.newItem.title,
                    detail: this.newItem.detail,
                    category: this.newItem.category.value,
                    label: this.newItem.label.value,
                    status: this.newItem.status,
                    date: date.getDay() + '.' + date.getMonth() + 1 + '.' + date.getFullYear(),
                    labelColor: this.newItem.label.color
                })
                this.newItem = {
                    title: '',
                    category: '',
                    detail: '',
                    label: '',
                    status: ''
                }
                this.hideModal('modalright')
            },
            selectAll(isToggle) {
                if (this.selectedItems.length >= this.items.length) {
                    if (isToggle) {
                        this.selectedItems = []
                    }
                } else {
                    this.selectedItems = this.items.map(x => x.id)
                }
            },
            keymap(event) {
                switch (event.srcKey) {
                    case 'select':
                        this.selectAll(false)
                        break
                    case 'undo':
                        this.selectedItems = []
                        break
                }
            },
            getIndex(value, arr, prop) {
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i][prop] === value) {
                        return i
                    }
                }
                return -1
            },
            toggleItem(event, itemId) {
                if (event.shiftKey && this.selectedItems.length > 0) {
                    let itemsForToggle = this.items
                    var start = this.getIndex(itemId, itemsForToggle, 'id')
                    var end = this.getIndex(this.selectedItems[this.selectedItems.length - 1], itemsForToggle, 'id')
                    itemsForToggle = itemsForToggle.slice(Math.min(start, end), Math.max(start, end) + 1)
                    this.selectedItems.push(
                        ...itemsForToggle.map(item => {
                            return item.id
                        })
                    )
                } else {
                    if (this.selectedItems.includes(itemId)) {
                        this.selectedItems = this.selectedItems.filter(x => x !== itemId)
                    } else {
                        this.selectedItems.push(itemId)
                    }
                }
            },
            handleContextmenu(vnode) {
                if (!this.selectedItems.includes(vnode.key)) {
                    this.selectedItems = [vnode.key]
                }
            },
            onContextCopy() {
                console.log('context menu item clicked - Copy Items: ', this.selectedItems)
            },
            onContextArchive() {
                console.log('context menu item clicked - Move to Archive Items: ', this.selectedItems)
            },
            onContextDelete() {
                console.log('context menu item clicked - Delete Items: ', this.selectedItems)
            }
        },

        mounted() {
            this.getTodoItems()
            document.body.classList.add("right-menu");
        },
        beforeDestroy() {
            document.body.classList.remove("right-menu");
        }
    }
</script>
